import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { LanguageId } from '@interfaces';
import { EmailSentRow } from '../person-emails-sent.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<EmailSentRow, unknown>[] = [
		buildColumn(util, 'Id', row => row.emailSentId, { header: 'emailSentId' }),
		buildColumn(util, 'Id', row => row.jobTriggerId, { header: 'jobTriggerId' }),
		buildColumn(util, 'Email', row => row.email, { header: 'Email', hidden: true }),
		buildColumn(util, 'Text', row => row.jobTriggerFunction, { header: 'Function', group: 'asc', hidden: true }),
		buildColumn(util, 'Text', row => row.jobTriggerName, { header: 'Trigger' }),
		buildColumn(util, 'Text', row => row.languageId === LanguageId.Espanol ? 'Spanish' : 'English', { header: 'Language' }),
		buildColumn(util, 'Text', row => row.highestEventName, { header: 'Highest Event' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.deliveredUTC), { header: 'Delivered Date', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.openedUTC), { header: 'Opened Date', hidden: true }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.createdUTC), { header: 'Sent Date', sort: 'desc' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.updatedUTC), { header: 'Updated Date', hidden: true }),
	];

	return columns;

}